<template>
	<div id="app">
		<div class="app-header" v-if="route.path !== '/login'">
			<div class="header-content">
				<h1>Scout Controle</h1>
				<div class="user-info">
					<span>{{ usuario?.nome }}</span>
					<button @click="logout" class="btn-logout">Sair</button>
				</div>
			</div>
		</div>

		<div class="connection-status" :class="{ offline: !online }">
			{{ online ? "Online" : "Offline" }}
		</div>

		<router-view />
	</div>
</template>

<script setup>

import { onMounted, onBeforeUnmount, ref, onBeforeMount } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();

const online = ref(navigator.onLine);
const usuario = ref(null);

const updateOnlineStatus = () => {
	online.value = navigator.onLine;
}

onMounted(() => {
	window.addEventListener("online", updateOnlineStatus);
	window.addEventListener("offline", updateOnlineStatus);

	const userData = localStorage.getItem("usuario");
	if (userData) {
		usuario.value = JSON.parse(userData);
	}
})

onBeforeUnmount(() => {
	window.removeEventListener("online", updateOnlineStatus);
	window.removeEventListener("offline", updateOnlineStatus);
})

function logout() {
	localStorage.removeItem('token');
	localStorage.removeItem('usuario');
	router.push("/login");
}

</script>